module.exports = "https://trybtryb-legacy.web.app/img/rounded-outline-desktop.cbce7ffc.svg";